import { randInt } from '../utils/fractionMath';
import { buildLatvianPhrase, LATVIAN_DENOMINATORS, LATVIAN_NUMERATORS } from '../utils/latvianWords';

const AVAILABLE_DENS = Object.keys(LATVIAN_DENOMINATORS).map(Number);

export function generateTopic4Questions(count = 10) {
  const questions = [];
  for (let i = 0; i < count; i++) {
    const den = AVAILABLE_DENS[randInt(0, AVAILABLE_DENS.length - 1)];
    const maxNum = Math.min(den - 1, 10);
    const availableNums = Object.keys(LATVIAN_NUMERATORS)
      .map(Number)
      .filter(n => n <= maxNum);
    const num = availableNums[randInt(0, availableNums.length - 1)];
    const phrase = buildLatvianPhrase(num, den);

    questions.push({
      id: `t4_${i}`,
      topicId: 4,
      type: 'word_to_fraction',
      prompt: 'Uzraksti daļu ciparu formātā:',
      data: { phrase, num, den },
      correctAnswer: { num, den },
    });
  }
  return questions;
}
